import type { Variants } from 'framer-motion'
import type { Direction } from '..'

export const toss: Variants = {
  initial: { x: 0, y: 0, rotate: 0, opacity: 1 },
  exit: ({ direction }: { direction: Direction }) => ({
    x: direction === 'left' ? -200 : 200,
    y: -100,
    rotate: direction === 'left' ? -45 : 45,
    opacity: 0,
    transition: { duration: 0.5, ease: 'easeIn' },
  }),
}
